import request from '@/utils/request'

/**
 * 获取文章列表
 */
export function getArticleList(data) {
  return request.get('/article/list', data)
}

/**
 * 获取文章详情
 */
export function getArticleDetail(data) {
  return request.get('/article/detail', data)
}
